export default __webpack_public_path__ + "static/media/banner-13.41b76747.jpg";